module.exports = __webpack_public_path__ + "img/7.da9bd562.jpg";